module.exports = [{
      plugin: require('/home/chun/Development/workspace/invimarc/invimarc-web/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/chun/Development/workspace/invimarc/invimarc-web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
